"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Mon Apr 08 2019
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var WindowMoveResultDTO_1 = require("../model/WindowMoveResultDTO");

var SupplierAgreementTransferValidationDTOConverter_1 = require("./SupplierAgreementTransferValidationDTOConverter");

var WindowItemTransferValidationDTOConverter_1 = require("./WindowItemTransferValidationDTOConverter");

var WindowMoveResultDTOConverter_1 = require("./WindowMoveResultDTOConverter");
/**
 * Default implementation of WindowMoveResultDTOConverter.
 *
 * @author Tomáš Leity
 * @author PKr
 */


var WindowMoveResultDTOConverterImpl =
/*#__PURE__*/
function (_WindowMoveResultDTOC) {
  _inherits(WindowMoveResultDTOConverterImpl, _WindowMoveResultDTOC);

  function WindowMoveResultDTOConverterImpl(windowItemValidation, supplierAgreementValidation) {
    var _this;

    _classCallCheck(this, WindowMoveResultDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowMoveResultDTOConverterImpl).call(this));
    _this.windowItemValidation = windowItemValidation;
    _this.supplierAgreementValidation = supplierAgreementValidation;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WindowMoveResultDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new WindowMoveResultDTO_1.WindowMoveResultDTO(WindowMoveResultDTO_1.WindowMoveResultDTO.schema.id.valueOf(conversions.toDocumentReferenceId(source.id)), WindowMoveResultDTO_1.WindowMoveResultDTO.schema.monitorId.valueOf(conversions.toClassReferenceId(source.monitorId)), WindowMoveResultDTO_1.WindowMoveResultDTO.schema.sourceWindowId.valueOf(conversions.toClassReferenceId(source.sourceWindowId)), WindowMoveResultDTO_1.WindowMoveResultDTO.schema.targetWindowId.valueOf(conversions.toClassReferenceId(source.targetWindowId)), WindowMoveResultDTO_1.WindowMoveResultDTO.schema.sessionId.valueOf(conversions.toClassReferenceId(source.sessionId)), conversions.asObjectList(source, 'windowItemValidation', function (validationResult) {
        return _this2.windowItemValidation.toObject(validationResult, conversions);
      }), conversions.asObjectList(source, 'supplierAgreementValidation', function (validationResult) {
        return _this2.supplierAgreementValidation.toObject(validationResult, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        id: conversions.toDocumentReferenceId(source.id),
        monitorId: conversions.toClassReferenceId(source.monitorId),
        sourceWindowId: conversions.toDocumentReferenceId(source.sourceWindowId),
        targetWindowId: conversions.toDocumentReferenceId(source.targetWindowId),
        sessionId: conversions.toDocumentReferenceId(source.sessionId),
        windowItemValidation: conversions.asObjectArray(source, 'windowItemValidation', function (validationResult) {
          return _this3.windowItemValidation.toDocument(validationResult, conversions);
        }),
        supplierAgreementValidation: conversions.asObjectArray(source, 'supplierAgreementValidation', function (validationResult) {
          return _this3.supplierAgreementValidation.toDocument(validationResult, conversions);
        })
      });
      return result;
    }
  }]);

  return WindowMoveResultDTOConverterImpl;
}(WindowMoveResultDTOConverter_1.WindowMoveResultDTOConverter);

WindowMoveResultDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [WindowItemTransferValidationDTOConverter_1.WindowItemTransferValidationDTOConverter, SupplierAgreementTransferValidationDTOConverter_1.SupplierAgreementTransferValidationDTOConverter])], WindowMoveResultDTOConverterImpl);
exports.WindowMoveResultDTOConverterImpl = WindowMoveResultDTOConverterImpl;